import React from 'react';
import { Table } from 'antd';
import JobStatus, { JOB_STATUS } from 'app/components/Status/JobStatus';
import Tooltip from 'app/components/Tooltip';
import { InspectionStaticCell, TextCell } from 'app/components/Table';

import get from 'lodash/get';
import moment from 'moment';
import { DateCell } from 'app/components/Table/Cells/DateCell';

export const getColumnDef = () => [
  {
    title: 'Job ID',
    dataIndex: 'jobNoList',
    width: 110,
    render: (value: { id: string; jobNo: string }) => {
      return <TextCell>{value.jobNo}</TextCell>;
    }
  },
  {
    title: 'Inspection type',
    dataIndex: 'typeOfService',
    width: 150,
    render: (value: string) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'Date Created',
    dataIndex: 'createdAt',
    width: 90,
    render: (value) => {
      return <DateCell value={value} format="DD MMM YYYY" />;
    }
  },
  {
    title: 'Inspector',
    dataIndex: 'assignTo',
    width: 150,
    render: (value: any[]) => {
      const inspectorNames = Array.isArray(value)
        ? value.map(({ firstName, lastName }) => {
            return `${firstName} ${lastName}`;
          })
        : [];
      return <TextCell>{inspectorNames.join(', ')}</TextCell>;
    }
  },
  {
    title: 'Inspection Date',
    dataIndex: 'inspectionDate',
    width: 150,
    render: (value: string) => {
      return (
        <TextCell>
          {value ? moment(value).format('DD MMM YYYY') : null}
        </TextCell>
      );
    }
  },
  {
    title: 'Supplier',
    dataIndex: 'inspectionSuppliers',
    width: 250,
    ellipsis: true,
    render: (value: any[]) => {
      const tSuppliers = [];
      (value || []).forEach((obj) => {
        if (obj.supplier) {
          tSuppliers.push(obj.supplier);
        }
      });
      const label = tSuppliers
        .map(
          (obj) => `${obj.name}${obj.supplierId ? ` (${obj.supplierId})` : ''}`
        )
        .filter((v) => !!v)
        .join(', ');
      const columnLabel = tSuppliers
        .map((obj) => obj.name)
        .filter((v) => !!v)
        .join(', ');
      return (
        <Tooltip title={label} placement="bottomLeft" isDark>
          <span>
            <TextCell>{columnLabel}</TextCell>
          </span>
        </Tooltip>
      );
    }
  },
  {
    title: 'Factory',
    dataIndex: 'inspectionFactory',
    width: 250,
    ellipsis: true,
    render: (value: { factory: Record<string, any> }) => {
      const label = [value?.factory?.name, value?.factory?.address]
        .filter((_) => !!_)
        .join(', ');
      return (
        <Tooltip title={label} placement="bottomLeft" isDark>
          <span>
            <TextCell>{label}</TextCell>
          </span>
        </Tooltip>
      );
    }
  },
  {
    title: 'Pass/Fail/Pending/Other',
    dataIndex: 'reportsResult',
    width: 190,
    render: (value: any) => {
      return <InspectionStaticCell {...value}></InspectionStaticCell>;
    }
  },
  {
    title: 'Date Updated',
    dataIndex: 'updatedAt',
    width: 90,
    render: (value) => {
      return <DateCell value={value} format="DD MMM YYYY" />;
    }
  },
  {
    title: 'Job Status',
    dataIndex: 'status',

    width: 160,
    render: (value: any) => {
      return (
        <JobStatus status={value}>{get(JOB_STATUS, value, 'N/A')}</JobStatus>
      );
    }
  },
  Table.EXPAND_COLUMN
];

export const getInspectionColumnDef = () => [
  Table.EXPAND_COLUMN,
  // {
  //   title: 'Name',
  //   dataIndex: 'clientName',
  //   render: (value: string) => {
  //     return <TextCell>{value}</TextCell>;
  //   }
  // },
  {
    title: 'Item Name',
    dataIndex: 'productProfile',
    render: (value: any) => {
      return <TextCell>{value?.name}</TextCell>;
    }
  },
  {
    title: 'Item No.',
    dataIndex: 'productProfile',
    render: (value: any) => {
      return <TextCell>{value?.itemNo}</TextCell>;
    }
  },
  {
    title: 'Order Qty',
    dataIndex: 'orderQty',
    render: (value: any) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'Carton Qty',
    dataIndex: 'cartonsNo',
    render: (value: any) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'Result',
    dataIndex: 'result',
    render: (value: any) => {
      return <TextCell>{value}</TextCell>;
    }
  }
];

export const MOCKED = [
  {
    id: '220000000',
    type: 'Internal QC',
    inspectionType: 'Final Random Inspection',
    inspector: '',
    inspectionDate: '11 May 2022',
    company: 'PRG',
    factory: 'Factory A - Guangzhou ,China',
    summary: '',
    status: 'waiting',
    inspections: [
      {
        name: 'Report 1',
        poNo: 12345,
        itemName: 'Item 1',
        itemNo: 12345,
        result: ''
      }
    ]
  }
];
